import { TrendingUp, TrendingDown, DollarSign, ArrowUpRight } from 'lucide-react';

export function AccountingCards({ data }) {
  const fmt = (a) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(a || 0);
  const inc = data.income || {};
  const exp = data.expenses || {};
  const prof = data.profit || {};
  const subs = data.subscriptions || {};

  return (
    <div className="grid grid-cols-4 gap-4">
      <div className="bg-white rounded-xl border border-gray-200 p-5">
        <div className="flex items-center justify-between mb-3">
          <p className="text-xs text-gray-400 uppercase font-semibold">Actual Income</p>
          <div className="w-8 h-8 rounded-lg bg-green-50 flex items-center justify-center"><TrendingUp className="w-4 h-4 text-green-600" /></div>
        </div>
        <p className="text-3xl font-bold text-green-600">{fmt(inc.total_paid)}</p>
        <p className="text-xs text-gray-500 mt-1">Planned: {fmt(inc.total_pending + inc.total_paid)}</p>
        <div className="mt-3 h-2 bg-gray-100 rounded-full overflow-hidden">
          <div className="h-full bg-green-500 rounded-full" style={{ width: `${Math.min(((inc.total_paid) / Math.max(inc.total_pending + inc.total_paid, 1)) * 100, 100)}%` }} />
        </div>
      </div>
      <div className="bg-white rounded-xl border border-gray-200 p-5">
        <div className="flex items-center justify-between mb-3">
          <p className="text-xs text-gray-400 uppercase font-semibold">Actual Expenses</p>
          <div className="w-8 h-8 rounded-lg bg-red-50 flex items-center justify-center"><TrendingDown className="w-4 h-4 text-red-500" /></div>
        </div>
        <p className="text-3xl font-bold text-red-500">{fmt(exp.monthly_total)}</p>
        <p className="text-xs text-gray-500 mt-1">Annual: {fmt(exp.annual_total)}</p>
        <div className="mt-3 h-2 bg-gray-100 rounded-full overflow-hidden">
          <div className="h-full bg-red-400 rounded-full" style={{ width: '100%' }} />
        </div>
      </div>
      <div className="bg-white rounded-xl border border-gray-200 p-5">
        <div className="flex items-center justify-between mb-3">
          <p className="text-xs text-gray-400 uppercase font-semibold">Net Profit</p>
          <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${prof.monthly >= 0 ? 'bg-green-50' : 'bg-red-50'}`}><DollarSign className={`w-4 h-4 ${prof.monthly >= 0 ? 'text-green-600' : 'text-red-500'}`} /></div>
        </div>
        <p className={`text-3xl font-bold ${prof.monthly >= 0 ? 'text-green-600' : 'text-red-500'}`}>{fmt(prof.monthly)}</p>
        <p className="text-xs text-gray-500 mt-1">{prof.margin_percent}% margin</p>
      </div>
      <div className="bg-white rounded-xl border border-gray-200 p-5">
        <div className="flex items-center justify-between mb-3">
          <p className="text-xs text-gray-400 uppercase font-semibold">MRR</p>
          <div className="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center"><ArrowUpRight className="w-4 h-4 text-[#014DB7]" /></div>
        </div>
        <p className="text-3xl font-bold text-[#014DB7]">{fmt(subs.mrr)}</p>
        <p className="text-xs text-gray-500 mt-1">ARR: {fmt(subs.arr)}</p>
      </div>
    </div>
  );
}
